import React, { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Modal from 'react-modal'

import Video from '../Video'

import * as styles from './index.module.css'

const FullWidthVideoCallout = ({
  title,
  subtitle,
  images,
  mobileOnlyImages,
  video_ref,
  ctaText,
  nodeLocale,
}) => {
  const [open, setOpen] = useState(false)

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 500
  const videoId = video_ref && video_ref.videoId
  const videoPlaylistId = video_ref && video_ref.videoPlaylistId
  const videoUrl = video_ref && video_ref.videoUrl
  const videoBackgroundImage = video_ref && video_ref.backgroundImage
  const videoOpts = {
    playerVars: {
      list: videoPlaylistId,
      modestbranding: 1,
      autoplay: 1,
      mute: isMobile ? 1 : 0,
      rel: 0,
    },
  }

  const videoDuration = video_ref && video_ref.videoDuration
  let image = images[0]
  if (isMobile && mobileOnlyImages) {
    image = mobileOnlyImages[0]
  }

  const toggleModal = () => setOpen(!open)

  return (
    <div className={styles.fullWidthVideoCalloutWrapper}>
      <GatsbyImage
        image={image.iphero}
        className={styles.background}
        imgStyle={{ objectFit: 'fill' }}
        alt={image?.description}
      />
      {videoDuration && <p className={styles.duration}>{videoDuration}</p>}
      <div className={styles.details}>
        <h2 className={styles.title}>{title}</h2>
        {subtitle !== null && (
          <p className={styles.subtitle}>{subtitle.subtitle}</p>
        )}
        <button className={styles.playButton} onClick={toggleModal}>
          {ctaText}
          <span className={styles.arrow}>→</span>
        </button>
      </div>
      <Modal
        isOpen={open}
        className={styles.videoWrapper}
        overlayClassName={styles.videoWrapperOverlay}
        onRequestClose={toggleModal}
        contentLabel="Video Player"
      >
        <div className={styles.videoPreview}>
          <Video
            videoId={videoId}
            videoOpts={videoOpts}
            videoUrl={videoUrl}
            videoBackgroundImage={videoBackgroundImage}
            nodeLocale={nodeLocale}
          />
        </div>
      </Modal>
    </div>
  )
}

export default FullWidthVideoCallout
